import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 获取角色列表
  getCharacterList(data) {
    const params = data
    return request({
      url: urlParams + '/role/list',
      type: 'get',
      params: params
    })
  },
  getRoleList(data) {
    const params = data
    return request({
      url: urlParams + '/role/roleList',
      type: 'get',
      params: params
    })
  },
  // 获取菜单列表
  getMenuNav(data) {
    const params = data
    return request({
      url: urlParams + '/menu/nav',
      type: 'get',
      params: params
    })
  },
  // 新增或角色列表
  addOrUpdataCharacter(data) { 
    const params = data
    return request({
      url: urlParams + '/role/saveOrUpdate',
      type: 'post',
      params: params
    })
  },
  //  删除角色
  delCharacter(data) {
    const params = data
    return request({
      url: urlParams + '/role/del',
      type: 'post',
      params: params
    })
  },
    //   包含角色菜单权限
    permissionsMenu(data) {
    const params = data
    return request({
      url: urlParams + '/role/info',
      type: 'get',
      params: params
    })
  },


}